import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=4942f36a"
import script from "./SectionTitle.vue?vue&type=script&lang=ts"
export * from "./SectionTitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4942f36a')) {
      api.createRecord('4942f36a', component.options)
    } else {
      api.reload('4942f36a', component.options)
    }
    module.hot.accept("./SectionTitle.vue?vue&type=template&id=4942f36a", function () {
      api.rerender('4942f36a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/common/SectionTitle.vue"
export default component.exports